<script setup>

    import Image from "@component/Image/Image.vue";
    import {ref} from "vue";

    const {images, thankYou} = STUDYKIK
    const {nextStep} = images;
    const {close} = STUDYKIK?.formLabels || '';
    const {
        nextSteps,
        nextStepsTitle,
        title
    } = thankYou

    const showCloseButton = ref(false)

    /**
     * Placeholder in case it is needed
     */
    const closeModal = () => {}

</script>

<template>
    <div class="thank-you">
        <div class="title-container">
            <h3
                class="title"
                v-html="title"
            />
        </div>
        <p
            class="next-steps-title"
            v-html="nextStepsTitle"
        />

        <div v-if="nextSteps.length">
            <div
                v-for="({content, title}) in nextSteps"
                class="next-step-container"
            >
                <Image
                    v-if="typeof nextStep === 'object'"
                    classes="next-step__icon"
                    :image="nextStep"
                />
                <img
                    v-else
                    class="next-step__icon"
                    :src="nextStep"
                    alt="Next Step Icon"
                />

                <div class="next-step__content">
                    <h3
                        class="next-step__title"
                        v-html="title"
                    />
                    <div
                        class="next-step__text"
                        v-html="content"
                    />
                </div>
            </div>
        </div>

        <div
            v-if="showCloseButton"
            class="thank-you__close"
        >
            <button
                class="btn-ext btn-ext--orange btn-ext--large"
                type="button"
                @click="closeModal"
                @keydown.prevent.enter="closeModal"
                v-html="close"
            />
        </div>

    </div>
</template>

<script>
    export default {
        name: "StudyKik Thank You"
    }
</script>

<style scoped lang="scss">

</style>
